<template>
    <button @click="switchButton" class='pull-left btn btn-sm btn-primary show-button'>
      {{ getButtonText }}
    </button>
</template>

<script>
export default {
  name: "SwitchBetweenColumnsButton",
  data() {
    return {}
  },
  methods: {
    switchButton() {
      return this.$store.commit('switchShowReducedRowsButton')
    },
  },
  computed: {
    getButtonText() {
      if (this.$store.getters.getShowReducedRows) {
        return this.$t('backend.importer_mapping.show_all')
      } else {
        return this.$t('backend.importer_mapping.show_import_only')
      }
    }
  }
}
</script>

<style scoped>

</style>